module.exports = __webpack_public_path__ + "img/Blast_Off_Club_House71.5641c8aa.jpg";